import { objectsDeepEqual } from '@1inch-community/core/utils';
import { AsyncDirective } from 'lit/async-directive.js';
import { directive, PartType } from 'lit/directive.js';
import { combineLatest, debounceTime, distinctUntilChanged, fromEvent, map, merge, startWith, tap, } from 'rxjs';
import { TextAnimateElement } from './text-animate.element';
class TextAnimateHoverDirective extends AsyncDirective {
    constructor() {
        super(...arguments);
        this.part = null;
    }
    update(part, props) {
        if (part.type !== PartType.ELEMENT) {
            throw new Error('textAnimateHover can only be used like inch-text-animate elements directive');
        }
        if (part.element.tagName.toLowerCase() !== TextAnimateElement.tagName.toLowerCase()) {
            throw new Error('textAnimateHover can only be applied to inch-text-animate elements');
        }
        this.part = part.element;
        return super.update(part, props);
    }
    render(options) {
        if (!options.target.value) {
            throw new Error('textAnimateHover: target element is not defined');
        }
        const mouse$ = merge(fromEvent(options.target.value, 'mouseenter').pipe(map(() => true)), fromEvent(options.target.value, 'mouseleave').pipe(map(() => false))).pipe(debounceTime(200), startWith(false));
        const text$ = combineLatest([options.text$, options.hoverText$, mouse$]).pipe(distinctUntilChanged(objectsDeepEqual), tap(([text, hoverText, isHover]) => {
            if (!this.part)
                return;
            if (isHover && !hoverText) {
                return;
            }
            this.part.text = (isHover ? hoverText : text);
            this.part.requestUpdate();
        }));
        this.subscription = text$.subscribe();
    }
    disconnected() {
        this.subscription?.unsubscribe();
    }
}
export const textAnimateHover = directive(TextAnimateHoverDirective);
//# sourceMappingURL=text-animate-hover.directive.js.map